module.exports = __webpack_public_path__ + "static/media/toonification5.dc6c01ab.jpg";